<template>
  <table class="table-sm" style="width: 100%; background: #95b4ff30">
    <thead>
      <tr>
        <th nowrap class="text-center border-gray" width="28%">Campo</th>
        <th nowrap class="text-center border-gray" width="36%">Valor antigo</th>
        <th nowrap class="text-center border-gray" width="36%">Valor novo</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(value, index) in displayFields" :key="index">
        <td :title="audit.id" class="border-gray">
          {{ getFieldLabel(index, audit.type) }}
        </td>
        <td class="text-center border-gray">
          {{
            typeof audit.old_values != 'undefined' && index != 'change_reason'
              ? audit.old_values[index]
              : '-'
          }}
        </td>
        <td class="text-center border-gray">
          {{ typeof value != 'undefined' ? value : '-' }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'PlanHistoryValuesTable',
  props: {
    audit: {
      type: Object,
    },
  },
  methods: {
    getFieldLabel(index, type) {
      const defaultFields = {
        change_reason: 'Motivo da alteração',
        name: 'Nome',
        product_id: 'Produtos',
        monthly_value: 'Valor da mensalidade',
        datas: 'Quantidade ou Valor de excedente',
      };
      return defaultFields[index] + (type ? ` - ${type}` : '');
    },
  },
  computed: {
    displayFields() {
      const filterFields = ['plan_id', 'type_id', 'id'];
      for (const [key, value] of Object.entries(this.audit.new_values)) {
        if (filterFields.includes(key)) {
          delete this.audit.new_values[key];
        }
      }
      return this.audit.new_values;
    },
  },
};
</script>
